"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var toastr = {
  maxAnimationDelay: 6000,
  newestOnTop: true,
  position: 'top-right',
  preventDuplicates: true
};
var _default = toastr;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-toastr/lib/config.js
// module id = 573
// module chunks = 0